// Libs
import React from 'react';
import { Box } from '@mui/material';

// Components
import Image from '../../../../Image';
import MyRating from '../../../../Rating/MyRating';
import ReportableIcon from '../../../../Products/Card/ReportableIcon';

const PRODUCT_IMAGE_SIZE_DESKTOP = 457;
const PRODUCT_IMAGE_SIZE_TABLET = 363;
const PRODUCT_IMAGE_SIZE_MOBILE = 320;

const ProductImageColumn = ({ product, unavailableWatermark, classes }) => {
  const { rating: isRatable, reportable: isReportable } = product || {};

  return (
    <Box
      flexGrow={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={1}
      className={classes.rightPart}>
      <div className={classes.imageContainer}>
        <Image
          src={product.image_link}
          imageContainer={{
            desktop: [PRODUCT_IMAGE_SIZE_DESKTOP],
            tablet: [PRODUCT_IMAGE_SIZE_TABLET],
            mobile: ['100%', PRODUCT_IMAGE_SIZE_MOBILE],
          }}
        />
        {unavailableWatermark}
      </div>
      {isReportable && <ReportableIcon withText />}
      {isRatable && <MyRating product={product} className={classes.myRating} />}
    </Box>
  );
};

export default ProductImageColumn;
